import { WebRTCCommonHelpers, HLSCommon } from '@streaming/mouflon-utils';

import { EPlayerType } from '@customTypes/common';

export const playerTypeChecker: Record<EPlayerType, () => Promise<boolean>> = {
  [EPlayerType.NATIVE]: () => Promise.resolve(true),
  [EPlayerType.WEBRTC]: async () =>
    WebRTCCommonHelpers.getIsWebRTCApiSupported() &&
    (await WebRTCCommonHelpers.isH264PlayingSupported()),
  [EPlayerType.BROADCAST]: async () =>
    WebRTCCommonHelpers.getIsWebRTCApiSupported() &&
    (await WebRTCCommonHelpers.isH264BroadcastSupported()),
  [EPlayerType.HLS]: async () => HLSCommon.isHLSSupported(),
  [EPlayerType.UNKNOWN]: () => Promise.resolve(false),
};
